import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/updates/')({
  component: () => <div>Hello /_authenticated/updates/!</div>,
})
